import React from 'react';
import { Provider } from 'react-redux';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { PostHogProvider } from 'posthog-js/react';
import { posthogConfig } from 'Douleutaras/app/lib/posthog/posthog.config';
import PusherContext from 'Douleutaras/app/PusherContext';
import { createRoutes } from 'Douleutaras/routes/dataRoutes';

let _router: ReturnType<typeof createBrowserRouter> | undefined;
const getRouter = () => {
  if (!_router) { _router = createBrowserRouter(createRoutes()); }
  return _router;
};

export const Client = ({ store: injectedStore, pusherChannel }) => (
  <PusherContext.Provider value={pusherChannel}>
    <Provider store={injectedStore}>
      <PostHogProvider {...posthogConfig}>
        <RouterProvider router={getRouter()} />
      </PostHogProvider>
    </Provider>
  </PusherContext.Provider>
);

export function createRender(container, store, pusherChannel): void {
  if (container.hasChildNodes()) {
    hydrateRoot(container, <Client store={store} pusherChannel={pusherChannel} />);
  } else {
    createRoot(container).render(<Client store={store} pusherChannel={pusherChannel} />);
  }
}
